import React from 'react';
const NAV = ['Services', 'Menu', 'About', 'Contact', 'Gallery'];
export function Footer() {
  return <footer className="w-full bg-canvas" data-id="element-101">
      <div className="flex flex-col gap-8 px-8 py-10 md:flex-row md:items-center md:justify-between md:px-16" data-id="element-102">
        <p className="text-white/40 text-xs uppercase tracking-[0.25em] order-2 md:order-1" data-id="element-103">
          © 2026 Sips and Nibbles
        </p>
        <nav aria-label="Footer utility navigation" className="order-1 md:order-2" data-id="element-104">
          <ul className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end" data-id="element-105">
            {NAV.map(label => <li key={label} data-id="element-106">
                <a href="#" className="text-white/70 hover:text-accent text-xs uppercase tracking-[0.25em] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent pb-1" data-id="element-107">
                  {label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}